
import { Component, Prop, Vue } from "vue-property-decorator";
import PModal from "@/components/look/PModal.vue";
import { BFormInput, BModal } from "bootstrap-vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { ISolCustomerEmployee } from "@/services";
import { i18n } from "@/i18n";

@Component({
  name: "document-validation-modal",
  components: {
    PModal,
    ValidationObserver,
    ValidationProvider,
  },
})
export default class DocumentValidationModal extends Vue {
  @Prop({ required: true }) public employee!: ISolCustomerEmployee;
  validationDocumentValueArray: string[] = [];

  random1 = 0;
  random2 = 1;

  $refs!: {
    documentValidationModal: InstanceType<typeof PModal>;
    input2: InstanceType<typeof BFormInput>[];
  };

  async showModal(): Promise<void> {
    this.validationDocumentValueArray = Array.from(this.employee.validationDocumentValue);

    if (this.validationDocumentValueArray.length > 2) {
      this.random1 = this.generateRandom();
      this.random2 = this.generateRandom(this.random1);

      if (this.random2 < this.random1) {
        const aux = this.random1;
        this.random1 = this.random2;
        this.random2 = aux;
      }

      this.validationDocumentValueArray[this.random1] = "";
      this.validationDocumentValueArray[this.random2] = "";
    } else {
      this.validationDocumentValueArray.forEach(() => "");
    }

    const pModal = this.$refs.documentValidationModal;
    const bModal = pModal.$children[0] as BModal;
    bModal.show();
  }

  hideModal(): void {
    this.random1 = 0;
    this.random2 = 1;
    this.validationDocumentValueArray = [];
    const pModal = this.$refs.documentValidationModal;
    const bModal = pModal.$children[0] as BModal;
    bModal.hide();
  }

  generateRandom(distinctOf?: number): number {
    let random = Math.floor(Math.random() * this.employee?.validationDocumentValue.length);

    if (distinctOf !== undefined && random === distinctOf) {
      random = this.generateRandom(distinctOf);
    }
    return random;
  }

  async onSubmit(): Promise<void> {
    if (this.validationDocumentValueArray.join("") === this.employee.validationDocumentValue) {
      this.$emit("success", this.employee);
      this.hideModal();
    } else {
      Vue.swal({
        title: i18n.t("label.documentValidation.invalid").toString(),
        icon: "error",
      });
    }
  }
}
